import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';

function DailyBetBackPromoFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK = brandId && (brandId == 35 || brandId == 36 || brandId == 37 || brandId == 49);
    const totalCashbackAmount = (brandId == 61) ? "$5" : isPK ? "PKR 150" : "₹50";
    const applicableExchangeType = isPK ? "PSL" : "IPL";

    return (
        <>
            <InformationWrapper>
                <Container>
                    <p className='top-para'>Play on Exchange with extra confidence on Fun88. If your first bet of the day loses,<br />receive a 100% CashBack bonus and continue playing with reduced risk every day.</p>
                </Container>
                <Container>
                    <KeyDetailsSec>
                        <MainTitle>How to participate</MainTitle>
                        <KeyDetailsSecWrap>
                            <KeyDetailsSecBox>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.DailyBetBackBonusIconOne}`}
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p>Place a cash bet on Cricket Matches on Exchange.</p>
                            </KeyDetailsSecBox>

                            <KeyDetailsSecBox>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.DailyBetBackBonusIconTwo}`}
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p>If your first bet of the day loses.</p>
                            </KeyDetailsSecBox>

                            <KeyDetailsSecBox>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.DailyBetBackBonusIconThree}`}
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                                <p>Receive a 100% daily CashBack bonus the next day.</p>
                            </KeyDetailsSecBox>
                        </KeyDetailsSecWrap>
                    </KeyDetailsSec>
                </Container>

                <Container>
                    <TermsAndCondition>
                        <MainTitle>Terms & Conditions</MainTitle>
                        <ul>
                            <li>Valid from 01 March 2026 to 31 May 2026.</li>
                            <li>Applicable on Exchange bets only for: {applicableExchangeType}.</li>
                            <li>Only the first losing bet of the day is eligible.</li>
                            <li>100% CashBack up to {totalCashbackAmount}.</li>
                            <li>Maximum benefit per player per day: {totalCashbackAmount}.</li>
                            <li>CashBack is credited as a non-withdrawable bonus.</li>
                            <li>Bonus wagering requirements apply.</li>
                            <li>Fun88 reserves the right to modify, suspend, or cancel the promotion without prior notice.</li>
                            <li>General Fun88 terms & conditions apply.</li>
                        </ul>
                    </TermsAndCondition>
                </Container>
            </InformationWrapper >
        </>
    )
}

export default withTheme(withAppContext(DailyBetBackPromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 1rem 0 5rem 0;
    gap: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    color: #444;
    background-color: #EBEBEB;
`;

const Container = styled.div`
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    background-color: #fff;
    padding: 2.5rem 1.5rem;
    border-radius: 8px;

    & .top-para {
        width: 100%;
        color: #444;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;

const MainTitle = styled.h4`
    width: 100%;
    color: #06A6FF;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
`;

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem 0;
    width: 75%;
    height: auto;
    gap: 2rem;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 1.5rem;
`;

const KeyDetailsSecBox = styled.div`
    width: 30%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    padding: 2rem 1.5rem;
    gap: 10px;
    border-radius: 6px;
    border: 1px solid #06A6FF;
    background: #06A6FF;

    .lazy-load-image-background {
        text-align: center;
        width: 61px;
        height: 61px;
    }

    img {
        width: 100%;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        text-transform: capitalize;
        margin: 3px 0px;
        width: 100%;
    }
`;

const TermsAndCondition = styled.div`
    width: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    padding: 0;
    gap: 2rem;
    
    ul {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin: 0;

        li {
            color: #444;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }
`;